/* ============ REVEAL — generic scroll-reveal utility ============
 * IntersectionObserver-based: elements with [data-reveal] get .is-revealed
 * added once they scroll into view. The CSS transition itself lives in
 * base.css, scoped under body.reveal-enabled so content stays visible by
 * default if this script never runs (progressive enhancement — see the
 * comment in base.css). Reusable as-is by later phases; no page-specific
 * logic here.
 */

function initReveal() {
  const targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return; // No-op on pages without reveal targets.

  document.body.classList.add('reveal-enabled');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach((el) => observer.observe(el));
}

export { initReveal };
